import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SharedModule, HttpLoaderFactory } from "./shared/shared.module";
import { AppRoutingModule } from "./app-routing.module";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from "@angular/common/http";
import { AppComponent } from "./app.component";
import { ToastrModule } from "ngx-toastr";
import { DecimalPipe } from "@angular/common";

import { CookieService } from "ngx-cookie-service";
import "hammerjs";
import "mousetrap";
import { AuthGuardService } from "./shared/guard/auth.guard";
import { JwtInterceptor } from "./shared/services/interceptor/jwt.interceptor";
import { authConfig } from "./shared/services/auth.config";
import { AuthService } from "./shared/services/auth.service";
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    SharedModule,
    AppRoutingModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    })
  ],
  providers: [AuthService,CookieService, DecimalPipe,{ provide:HTTP_INTERCEPTORS,useClass:JwtInterceptor,multi:true }],
  bootstrap: [AppComponent],
})
export class AppModule {}